import GrowthRate from './GrowthRate';

export default GrowthRate;
